import { themeService } from '../services/theme/ThemeService';
import { EnvironmentService } from '../services/EnvironmentService';
import React from 'react';
import { withThemeLoader } from '../decorators/withThemeLoader';

const envService = new EnvironmentService();

export class AdminLoader {
  
  static Layout = null;
  
  static theme = null;
  
  static async load(callback) {
    window._ = (await import('lodash')).default;
    
    if (envService.is2Eskimos) {
      await import(/* webpackChunkName: "base-theme" */ 'base/index.less');
      AdminLoader.theme = themeService.THEMES.THEME_DEFAULT;
    } else if (envService.is2bap) {
      await import(/* webpackChunkName: "base-2bap-partial-theme" */ '2bap-partial/index.less');
      AdminLoader.theme = themeService.THEMES.THEME_TO_BUILD_A_PROFILE_PARTIAL;
    } else if(envService.isKutubee) {
      await import(/* webpackChunkName: "kutubee-admin-theme" */ 'kutubee-admin/index.less');
      AdminLoader.theme = themeService.THEMES.THEME_KUTUBEE_ADMIN;
    }
    
    if (!AdminLoader.Layout) {
      const rawLayout = await import(/* webpackChunkName: "admin-module-layout" */ './layouts/moduleLayout');
      AdminLoader.Layout = withThemeLoader(rawLayout.default, AdminLoader.theme);
    }
    callback(null, AdminLoader.Layout);
  }
  
}

